import { runSmartSubnav } from '../../snippets/smart-subnav/smart-subnav';
import { initProduct } from '../../snippets/product-base/product-base';
import { initProductSmartPlugInstallation } from './product-smart-plug-installation/product-smart-plug-installation';
import { initCollapsiblePlugTechSpecsMenu } from './product-smart-plug-tech-specs/product-smart-plug-tech-specs';
import { initCollapsibleRows } from '../../snippets/collapsible-rows/collapsible-rows';

runSmartSubnav({
  intersectionThreshold: [0, 0.2],
  intersectionRatio: 0.2,
});

initProduct();
initProductSmartPlugInstallation();
initCollapsiblePlugTechSpecsMenu();
initCollapsibleRows();
